import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ApiService } from 'src/app/services/api.service';
import { LoaderComponent } from '../../components/loader/loader.component';

@Component({
  selector: 'app-device-user-data',
  templateUrl: './device-user-data.page.html',
  standalone: true,
  imports: [LoaderComponent, TranslateModule],
})
export class DeviceUserDataPage implements OnInit {
  public loading: boolean = true;
  private interval: ReturnType<typeof setInterval>;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.interval = setInterval(async () => {
      const result = await this.apiService
        .identifiedGet('/api/v3/device-user/migration')
        .toPromise();
      if (true === result) {
        clearInterval(this.interval);
        this.apiService.presentToast(
          this.translateService.instant('page.login.success'),
          1500,
          'bottom'
        );
        setTimeout(() => {
          this.router.navigate(['feed'], { replaceUrl: true });
        }, 1000);
        this.loading = false;
      }
    }, 1000);
  }
}
